// @core/api/endpoints/secret/issue_certificate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CertificateResponse,
  IssueCertificateRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Issue certificate
 * Issues a new leaf certificate using the specified PKI role. The role defines allowed domains, key types, and TTL constraints. Returns the certificate, private key, and CA chain.
 */
export async function IssueCertificate(
  engine_id: string,
  role_name: string,
  data: IssueCertificateRequest,
  options?: RequestOptions
): Promise<CertificateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/issue/:role_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':role_name', encodeURIComponent(role_name));
  const requestOptions = options;
  return client.post<CertificateResponse>(requestPath, data, requestOptions);
}
